// extracted by mini-css-extract-plugin
export default {"container":"LoginLayout-module__container--f34ZN","main":"LoginLayout-module__main--SXU2d","contentArea":"LoginLayout-module__contentArea--VJRbL"};